import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SolarScene from "./SolarScene";
import { useSite } from "@/context/SiteContext";
import { SERVICES } from "@/lib/services";

export default function ServiceExplorer({ initialId = "commercial" }) {
  const { config, openLead } = useSite();
  const [current, setCurrent] = useState(SERVICES.find((s) => s.id === initialId));
  const [answer, setAnswer] = useState("");

  useEffect(() => {
    try {
      const saved = JSON.parse(sessionStorage.getItem("sbb-service-answer"));
      if (saved && saved.id === current.id && current.options.includes(saved.answer)) setAnswer(saved.answer);
      else setAnswer("");
    } catch (e) {
      setAnswer("");
    }
  }, [current]);

  function select(id) {
    const next = SERVICES.find((s) => s.id === id);
    if (next) setCurrent(next);
  }

  return (
    <div className="service-layout" data-testid="service-explorer">
      <div className="service-nav" role="group" aria-label="Explore energy solutions" data-testid="service-nav">
        {SERVICES.filter((s) => config.enabledServices.includes(s.id)).map((s) => (
          <button
            key={s.id}
            className={`service-button ${s.id === current.id ? "selected" : ""}`}
            data-service={s.id}
            aria-pressed={s.id === current.id}
            data-testid={`service-nav-${s.id}`}
            onClick={() => select(s.id)}
          >
            <span aria-hidden="true">{s.icon}</span>
            {s.name}
          </button>
        ))}
      </div>
      <article className="service-stage" data-testid="service-stage">
        <SolarScene kind={current.id} state={{ coverage: 65, batteries: 2 }} testId={`service-scene-${current.id}`} />
        <div className="service-copy">
          <span className="eyebrow" data-testid="service-label">{current.tag}</span>
          <h3 data-testid="service-title">{current.name}</h3>
          <p data-testid="service-description">{current.description}</p>
          <div className="question">
            <label className="field" htmlFor="service-question" style={{ margin: 0 }}>
              {current.question}
            </label>
            <select id="service-question" data-testid="service-question" value={answer} onChange={(e) => {
              setAnswer(e.target.value);
              try {
                sessionStorage.setItem("sbb-service-answer", JSON.stringify({ id: current.id, answer: e.target.value }));
              } catch (err) {}
            }}>
              <option value="">Choose one…</option>
              {current.options.map((t) => (
                <option key={t} value={t}>
                  {t}
                </option>
              ))}
            </select>
          </div>
          <Link className="btn" to={`/services/${current.id}`} data-testid={`explore-${current.id}`}>
            Explore {current.name.toLowerCase()} <span>↗</span>
          </Link>{" "}
          <button className="btn light" data-testid="assess-service" onClick={() => openLead(current.id, current.name, { audience: current.audience, serviceAnswer: answer })}>
            Request assessment <span>↗</span>
          </button>
          <details>
            <summary>{current.faq}</summary>
            <p>{current.answer}</p>
          </details>
        </div>
      </article>
    </div>
  );
}
